type OS = 'Windows' | 'MacOS' | 'Linux' | 'Unknown';

const getOS = (): OS => {
  const { userAgent } = window.navigator;
  if (userAgent.indexOf('Win') !== -1) return 'Windows';
  if (userAgent.indexOf('Mac') !== -1) return 'MacOS';
  if (userAgent.indexOf('Linux') !== -1) return 'Linux';
  return 'Unknown';
};

export const os = getOS();

export const isMac = os === 'MacOS';
